const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");

const splitDate = (text = "") => {
  const [day = "", month = "", year = ""] = String(text).split("/");
  return {
    day: day.replace(/\D/g, "").slice(0, 2).padStart(2, "0"),
    month: month.replace(/\D/g, "").slice(0, 2).padStart(2, "0"),
    year: year.replace(/\D/g, "").slice(0, 4),
  };
};

const fmtQty = (value) => {
  const num = Number(value || 0);
  if (!Number.isFinite(num)) return "";
  if (Math.abs(num - Math.trunc(num)) < 0.000001) return `${Math.trunc(num)}`;
  return num.toFixed(3).replace(/\.0+$/, "").replace(/(\.\d*?)0+$/, "$1");
};

const fmtMoney = (value) => new Intl.NumberFormat("vi-VN").format(Math.round(Number(value) || 0));

export const getPrintTemplate = ({ headerInfo, committeeMembers, rows, totals }) => {
  const date = splitDate(headerInfo.inventoryDate);

  const committeeRows = (committeeMembers || [])
    .map(
      (member) => `
      <div style="margin-bottom:4px;">
        Ông/Bà ${escapeHtml(member.fullName || "....................")} Chức vụ ${escapeHtml(
        member.position || "................"
      )} Đại diện ${escapeHtml(member.representative || "................")} ${escapeHtml(
        member.role || ""
      )}
      </div>
    `
    )
    .join("");

  const rowsHtml = (rows || [])
    .map(
      (row, index) => `
      <tr>
        <td class="center">${index + 1}</td>
        <td>${escapeHtml(row.itemName || "")}</td>
        <td class="center">${escapeHtml(row.itemCode || "")}</td>
        <td class="center">${escapeHtml(row.unit || "")}</td>
        <td class="right">${fmtMoney(row.unitPrice)}</td>
        <td class="right">${fmtQty(row.bookQuantity)}</td>
        <td class="right">${fmtMoney(row.bookAmount)}</td>
        <td class="right">${fmtQty(row.actualQuantity)}</td>
        <td class="right">${fmtMoney(row.actualAmount)}</td>
        <td class="right">${fmtQty(row.surplusQuantity)}</td>
        <td class="right">${fmtMoney(row.surplusAmount)}</td>
        <td class="right">${fmtQty(row.shortageQuantity)}</td>
        <td class="right">${fmtMoney(row.shortageAmount)}</td>
        <td class="right">${fmtQty(row.goodQuantity)}</td>
        <td class="right">${fmtQty(row.poorQuantity)}</td>
        <td class="right">${fmtQty(row.lostQuantity)}</td>
      </tr>
    `
    )
    .join("");

  return `
  <html>
    <head>
      <meta charset="utf-8" />
      <title>Biên Bản Tổng Hợp Kiểm Kê</title>
      <style>
        @media print { @page { margin: 10mm 8mm 14mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; font-size: 14px; color:#000; margin: 0; padding: 12px; }
        .header { display:flex; justify-content:space-between; align-items:flex-start; }
        .left { line-height:1.4; }
        .right { text-align:center; line-height:1.35; }
        .title { text-align:center; margin-top:10px; font-size:26px; font-weight:700; text-transform:uppercase; }
        .meta-right { text-align:right; margin-top:6px; }
        table { width:100%; border-collapse:collapse; margin-top:10px; font-size:12.5px; }
        th, td { border:1px solid #000; padding:3px; vertical-align:middle; }
        th { text-align:center; font-weight:700; }
        .center { text-align:center; }
        .right { text-align:right; }
        .signatures { margin-top:22px; display:flex; justify-content:space-between; text-align:center; }
        .sign-col { width:24%; }
        .sign-col-wide { width:28%; }
        .sign-spacer { height: 16px; }
        .page-number { position: fixed; right: 8mm; bottom: 6mm; font-size: 11px; }
      </style>
    </head>
    <body>
      <div class="header">
        <div class="left">
          <div><b>Đơn vị:</b> ${escapeHtml(headerInfo.unit || "")}</div>
          <div><b>Bộ phận:</b> ${escapeHtml(headerInfo.department || "")}</div>
        </div>
        <div class="right">
          <div><b>Mẫu số: 05 - VT</b></div>
          <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC</i></div>
          <div><i>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
        </div>
      </div>

      <div class="title">BIÊN BẢN TỔNG HỢP KIỂM KÊ VẬT TƯ, CÔNG CỤ, SẢN PHẨM, HÀNG HÓA</div>
      <div class="meta-right">Số: ${escapeHtml(headerInfo.documentNumber || "")}</div>

      <div style="margin-top:6px;">- Thời điểm kiểm kê ${escapeHtml(headerInfo.inventoryHour || "")}
        giờ ngày ${date.day || "..."} tháng ${date.month || "..."} năm ${date.year || "...."}</div>

      <div style="margin-top:4px;">- Ban kiểm kê/Hội đồng kiểm kê gồm:</div>
      ${committeeRows}
      <div style="margin-top:4px;">- Đã kiểm kê kho có những mặt hàng dưới đây:</div>

      <table>
        <thead>
          <tr>
            <th rowspan="3">STT</th>
            <th rowspan="3">Tên, nhãn hiệu, quy cách vật tư, dụng cụ,...</th>
            <th rowspan="3">Mã số</th>
            <th rowspan="3">Đơn vị tính</th>
            <th rowspan="3">Đơn giá</th>
            <th colspan="2">Theo sổ kế toán</th>
            <th colspan="2">Theo kiểm kê</th>
            <th colspan="4">Chênh lệch</th>
            <th colspan="3">Phẩm chất</th>
          </tr>
          <tr>
            <th rowspan="2">Số lượng</th>
            <th rowspan="2">Thành tiền</th>
            <th rowspan="2">Số lượng</th>
            <th rowspan="2">Thành tiền</th>
            <th colspan="2">Thừa</th>
            <th colspan="2">Thiếu</th>
            <th rowspan="2">Còn tốt 100%</th>
            <th rowspan="2">Kém phẩm chất</th>
            <th rowspan="2">Mất phẩm chất</th>
          </tr>
          <tr>
            <th>Số lượng</th>
            <th>Thành tiền</th>
            <th>Số lượng</th>
            <th>Thành tiền</th>
          </tr>
          <tr>
            <th>A</th><th>B</th><th>C</th><th>D</th><th>1</th><th>2</th><th>3</th><th>4</th><th>5</th><th>6</th><th>7</th><th>8</th><th>9</th><th>10</th><th>11</th><th>12</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
          <tr>
            <td colspan="5" class="center"><b>Cộng</b></td>
            <td class="right"><b>${fmtQty(totals.bookQuantity)}</b></td>
            <td class="right"><b>${fmtMoney(totals.bookAmount)}</b></td>
            <td class="right"><b>${fmtQty(totals.actualQuantity)}</b></td>
            <td class="right"><b>${fmtMoney(totals.actualAmount)}</b></td>
            <td class="right"><b>${fmtQty(totals.surplusQuantity)}</b></td>
            <td class="right"><b>${fmtMoney(totals.surplusAmount)}</b></td>
            <td class="right"><b>${fmtQty(totals.shortageQuantity)}</b></td>
            <td class="right"><b>${fmtMoney(totals.shortageAmount)}</b></td>
            <td class="right"><b>${fmtQty(totals.goodQuantity)}</b></td>
            <td class="right"><b>${fmtQty(totals.poorQuantity)}</b></td>
            <td class="right"><b>${fmtQty(totals.lostQuantity)}</b></td>
          </tr>
        </tbody>
      </table>

      <div class="signatures">
        <div class="sign-col-wide">
          <div class="sign-spacer"></div>
          <div><b>Giám đốc</b></div>
          <div><i>(Ý kiến giải quyết số chênh lệch)</i></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Kế toán trưởng</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col">
          <div class="sign-spacer"></div>
          <div><b>Thủ kho</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
        <div class="sign-col-wide">
          <div><i>Ngày... tháng... năm...</i></div>
          <div><b>Trưởng ban/Chủ tịch Hội đồng kiểm kê</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
      </div>

      <div class="page-number">1/1</div>
      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>
  `;
};
